import { Component } from "@angular/core";
import { TableIndexActionComponent } from "../table-index-action/table-index-action.component";

@Component({
  selector: "app-table-index-edit-action",
  templateUrl: "./table-index-edit-action.component.html",
  styleUrls: ["./table-index-edit-action.component.scss"],
})
export class TableIndexEditActionComponent extends TableIndexActionComponent {}
